import { Footer } from "@faire/deprecated-retailer-visitor-shared/components/Footer/index";
import { KeepExploringCarousel } from "@faire/deprecated-retailer-visitor-shared/components/KeepExploringCarousel";
import { SignUpBanner } from "@faire/deprecated-retailer-visitor-shared/components/SignUpBanner/SignUpBanner";
import { PaddedContainer } from "@faire/deprecated-retailer-visitor-shared/features/Marketplace/style";
import {
  popSignUp,
  SignUpElement,
  SignUpType,
} from "@faire/deprecated-retailer-visitor-shared/lib/popSignUp";
import { useLoggedOutSuppliersPageCurrentCategory } from "@faire/deprecated-retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/Context/useLoggedOutSuppliersPageCurrentCategory";
import { MaybeLoggedOutSuppliersPageMwebCategoryCarousel } from "@faire/deprecated-retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/LoggedOutSuppliersPage/__internal__/Components/LoggedOutSuppliersPageHeader/LoggedOutSuppliersPageMwebCategoryCarousel";
import { LoggedOutSuppliersPageLayoutElements } from "@faire/deprecated-retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/LoggedOutSuppliersPage/__internal__/Components/LoggedOutSuppliersPageLayoutElements/LoggedOutSuppliersLayoutElements";
import { LoggedOutSuppliersPageLogErrorEffect } from "@faire/deprecated-retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/LoggedOutSuppliersPage/__internal__/Components/LoggedOutSuppliersPageLogErrorEffect";
import { LoggedOutSuppliersPagePagination } from "@faire/deprecated-retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/LoggedOutSuppliersPage/__internal__/Components/LoggedOutSuppliersPagePagination";
import { MaybeLoggedOutSuppliersPageSEOTextBlockContent } from "@faire/deprecated-retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/LoggedOutSuppliersPage/__internal__/Components/MaybeLoggedOutSuppliersPageSEOTextBlockContent";
import { LoggedOutSuppliersPageResults } from "@faire/deprecated-retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/LoggedOutSuppliersPage/__internal__/LoggedOutSuppliersPageResults";
import { useLoggedOutSuppliersPageScroll } from "@faire/deprecated-retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/LoggedOutSuppliersPage/__internal__/useScrollToBrandsSection";
import { LoggedOutSuppliersPageEffects } from "@faire/deprecated-retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/LoggedOutSuppliersPage/LoggedOutSuppliersPageEffects";
import { LoggedOutSuppliersPageHelmet } from "@faire/deprecated-retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/LoggedOutSuppliersPage/LoggedOutSuppliersPageHelmet";
import { trackRetailersPageViewView } from "@faire/web-api--source/events/retailers/view/pageView";
import { trackSignupModalOpenCatnavBottomCtaClick } from "@faire/web-api--source/events/signup/click/modalOpenCatnavBottomCta";
import { ILayoutElement } from "@faire/web-api--source/indigofair/data/ILayoutElement";
import { getWindowOrThrow } from "@faire/web/common/globals/getWindow";
import { Column, HorizontalLine } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { WhenVisibilityIsImminent } from "@faire/web/ui/VisibilitySensor/WhenVisibilityIsImminent";
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useHistory } from "react-router-dom";

export const LoggedOutSuppliersPage: React.FC = () => {
  return (
    <>
      <LoggedOutSuppliersPageHelmet />
      <LoggedOutSuppliersPageEffects />
      <LoggedOutSuppliersPageLogErrorEffect />
      <LoggedOutSuppliersPageBase />
    </>
  );
};

const LoggedOutSuppliersPageBase = () => {
  const categoryModel = useLoggedOutSuppliersPageCurrentCategory();
  const history = useHistory();

  const { scrollToBrandsSectionRef, scrollToBrandsSection } =
    useLoggedOutSuppliersPageScroll();

  const { pathname } = useLocation();
  const [c1, c2, c3] = categoryModel.urlIdStrings;

  useEffect(() => {
    trackRetailersPageViewView(
      "",
      "",
      "",
      "suppliers",
      pathname,
      "page-suppliers",
      c1 ?? "",
      c2 ?? "",
      c3 ?? ""
    );
  }, [pathname, c1, c2, c3]);

  if (!categoryModel) {
    return null;
  }

  return (
    <Column>
      <LoggedOutSuppliersPageLayoutElements
        type={[ILayoutElement.Type.AVATAR_CAROUSEL_WITH_GRID]}
      />
      <Spacer height={{ mobileAndAbove: "2x", desktopAndAbove: 0 }} />
      <LoggedOutSuppliersPageLayoutElements
        type={[
          ILayoutElement.Type.MOST_POPULAR_BRANDS,
          ILayoutElement.Type.TESTIMONIAL_CAROUSEL,
        ]}
      />

      <MaybeLoggedOutSuppliersPageMwebCategoryCarousel />

      <Spacer height="3x" ref={scrollToBrandsSectionRef} />

      <LoggedOutSuppliersPageResults
        scrollToBrandsSection={scrollToBrandsSection}
      />

      <LoggedOutSuppliersPagePagination
        scrollToBrandsSection={scrollToBrandsSection}
      />
      <HorizontalLine />

      <Spacer height="5x" />

      <PaddedContainer $noPaddingOnMobile>
        <WhenVisibilityIsImminent>
          <LoggedOutSuppliersPageLayoutElements
            type={[ILayoutElement.Type.AVATAR_CAROUSEL]}
          />
        </WhenVisibilityIsImminent>
        <KeepExploringCarousel
          dataTestId="logged-out-suppliers-page-keep-exploring"
          clickTrackPath="logged-out-category/keep-exploring-carousel"
          removeCategoryPath={categoryModel.pathIdentifier}
          onClick={() => {
            getWindowOrThrow().scrollTo?.(0, 0);
          }}
        />
      </PaddedContainer>
      <Spacer height="5x" />
      <SignUpBanner
        onClick={() =>
          popSignUp(
            history,
            SignUpType.GENERIC,
            trackSignupModalOpenCatnavBottomCtaClick,
            {
              element: SignUpElement.BELOW_FOLD,
              sourceId: "logged_out_suppliers_page_bottom_signup_cta",
            }
          )
        }
      />
      <MaybeLoggedOutSuppliersPageSEOTextBlockContent />
      <Footer />
    </Column>
  );
};
